import SortingIcon from '../svgIcons/SortingIcon';
import SortingAscendingIcon from '../svgIcons/SortingAscendingIcon';
import SortingDescendingIcon from '../svgIcons/SortingDescendingIcon';
import styled from 'styled-components';
import React from 'react';

const TableHeader = ({
  columns,
  insideDashboard,
  sortColumn,
  onSort,
  mainHeading,
  websiteOrders
}) => {
  const raiseSort = (path) => {
    if (!path) return;
    const sort = { ...sortColumn };
    if (sort.path === path)
      sort.order = sortColumn.order === 'ASC' ? 'DESC' : 'ASC';
    else {
      sort.path = path;
      sort.order = 'DESC';
    }
    onSort(sort);
  };

  const renderSortIcon = (column) => {
    if (!column?.path) return;
    if (sortColumn?.order === 'ASC' && sortColumn.path === column.path)
      return <SortingAscendingIcon />;
    if (sortColumn?.order === 'DESC' && sortColumn.path === column.path)
      return <SortingDescendingIcon />;
    return <SortingIcon />;
  };

  return (
    <StyledTHead 
    websiteOrders={websiteOrders}>
      {mainHeading &&
        mainHeading.length > 0 &&
        (() => {
          let currentColumnIndex = 1;

          return (
            <tr style={{ backgroundColor: '#f9f9f9' }}>
              {mainHeading.map((heading, index) => {
                const emptyColumns = heading.from - currentColumnIndex;

                // Capture the fragment for empty and heading columns
                const fragment = (
                  <React.Fragment key={index}>
                    {/* Render empty th elements for the gap before the current heading */}
                    {[...Array(emptyColumns)].map((_, idx) => (
                      <th
                        key={`empty-th-${idx}-${index}`}
                        style={{ ...(heading?.emptyHeadingStyle || {}) }}
                      ></th>
                    ))}

                    {/* Render the main heading */}
                    <th
                      colSpan={heading.to - heading.from + 1}
                      style={{
                        textAlign: 'center',
                        ...(heading?.style || {}),
                      }}
                    >
                      {heading.name}
                    </th>
                  </React.Fragment>
                );

                // Update the currentColumnIndex after rendering the heading
                currentColumnIndex = heading.to + 1;

                return fragment;
              })}

              {/* Render empty th elements after the last heading if there are remaining columns */}
              {[...Array(columns.length - currentColumnIndex + 1)].map(
                (_, idx) => (
                  <th
                    key={`empty-th-after-${idx}`}
                    style={{ backgroundColor: '#f9f9f9' }}
                  ></th>
                ),
              )}
            </tr>
          );
        })()}
      <tr>
        {columns.map((column) => (
          <th
            key={`${column.id || column.key}-th-${column?.label}`}
            className={`${column?.path ? 'cursor-pointer' : ''}`}
            style={{
              ...(column.fixed
                ? { position: 'sticky', left: 0, zIndex: 1 }
                : {}),
              ...(column.style || {}),
              ...(column.headerStyle || {}),
            }}
          >
            <div
              className={`d-flex align-items-center ${column?.path ? '' : ''} ${
                column?.alignHeader ? column?.alignHeader : ''
              }`}
            >
              {column.checkBox ? (
                <div className="d-flex align-items-center gap-2 gap-md-4">
                  {column.checkBox}
                  {column.label}
                  {renderSortIcon(column)}
                </div>
              ) : column?.labelComponent ? (
                column.labelComponent
              ) : (
                <span
                  className="d-flex align-items-center gap-2"
                  onClick={() => onSort && raiseSort(column.path)}
                >
                  {column.label}
                  {column.icon && column.icon}
                  {renderSortIcon(column)}
                </span>
              )}
            </div>
          </th>
        ))}
        {/* {pathname.includes('orders') && <th>Chat</th>} */}
      </tr>
      {insideDashboard && <tr></tr>}
    </StyledTHead>
  );
};

const StyledTHead = styled.thead`
  th {
    padding: ${({ websiteOrders }) =>  websiteOrders ? '24px 16px' : '24px 24px'} !important;
  }
`;
export default TableHeader;
